import { isAvailableExtensions } from '@/vendors/tiptap/helpers'

export default ({ config = [], extensions = [] }) => {
  const keys = {
    bold: ['bold'],
    italic: ['italic'],
    underline: ['underline'],
    blockquote: ['quote_right'],
    heading: ['heading_h1', 'heading_h2'],
    textStyle: ['text_color'],
    color: ['text_color'],
    link: ['link'],
    embed: ['video', 'code'],
    image: ['image'],
    bulletList: ['list_ul'],
    orderedList: ['list_ol'],
    listItem: ['list_ul', 'list_ol'],
    textAlign: ['align_left', 'align_center', 'align_right']
  }

  return extensions.filter(({ name }) => keys[name] ? isAvailableExtensions({ config, extensions: keys[name] }) : true)
}